import React from 'react';
import AgentSidebar from '../AgentSidebar';
import AgentChatArea from '../AgentChatArea';

export default function AgentConversations({
  agents,
  selectedAgent,
  onSelectAgent,
  onSendMessage,
}) {
  return (
    <div className="flex h-full">
      <AgentSidebar
        agents={agents}
        selectedAgent={selectedAgent}
        onSelectAgent={onSelectAgent}
      />
      <AgentChatArea
        agent={agents.find((a) => a.id === selectedAgent)}
        onSendMessage={onSendMessage}
      />
    </div>
  );
}
